import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderItemReceiveMethodTypes = {
  QUANTITY: 0,
  CURRENCY_AMOUNT: 1,
} as const

export type OrderItemReceiveMethodEnum = Enum<
  typeof OrderItemReceiveMethodTypes
>
